import { render } from "./PageLoglar.vue?vue&type=template&id=0172a6dc"
import script from "./PageLoglar.vue?vue&type=script&lang=js"
export * from "./PageLoglar.vue?vue&type=script&lang=js"
script.render = render

export default script